import { Box, styled } from '@mui/material';

/**
 * CSS-in-JS styles for the MenuWrapper component.
 * This styles the menu wrapper and its subcomponents, setting various properties.
 *
 * @param {object} theme - The theme object used for styling.
 */
export const MenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {
      padding: 0px;

      & > .MuiList-root {
        padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
      }
    }

      .MuiListSubheader-root {
        text-transform: uppercase;
        font-weight: bold;
        font-size: ${theme.typography.pxToRem(12)};
        color: ${theme.colors.alpha.trueWhite[50]};
        padding: ${theme.spacing(0, 2.5)};
        line-height: 1.4;
      }
  `
);

/**
 * CSS-in-JS styles for the SubMenuWrapper component.
 * This styles the sub-menu wrapper and its subcomponents, setting various properties.
 *
 * @param {object} theme - The theme object used for styling.
 */
export const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
      .MuiList-root {

        .topOption {
          padding-top: 14px !important;
        }

        .MuiListItem-root {
          padding: 7px 0;


          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(3.2)};

            .MuiBadge-standard {
              background: ${theme.colors.primary.main};
              font-size: ${theme.typography.pxToRem(10)};
              font-weight: bold;
              text-transform: uppercase;
              color: var(--color-white);
            }
          }

          .MuiButton-root {
            display: flex;
            color: var(--color-white);
            background-color: transparent;
            margin-left: 8px;
            width: 232px;
            height: 50px;
            font-weight: 700;
            justify-content: flex-start;
            padding: ${theme.spacing(1.2, 2.2)};
            border-radius: 6px;
            .MuiButton-startIcon,
            .MuiButton-endIcon {
              transition: ${theme.transitions.create(['color'])};
              .MuiSvgIcon-root {
                font-size: inherit;
                transition: none;
              }
            }

            .MuiButton-startIcon {
              color: var(--color-white);
              font-size: ${theme.typography.pxToRem(22)};
              margin-right: ${theme.spacing(1)};
            }

            .MuiButton-endIcon {
              color: var(--color-white);
              margin-left: auto;
              opacity: .8;
              font-size: ${theme.typography.pxToRem(22)};
            }

            &.active,
            &:hover {
                width: 232px;
                background: #463E61;
                border-radius: 6px;
                color: var(--color-bg-muted-alt);
                height: 50px;
                font-weight: 700;
              .MuiButton-startIcon,
              .MuiButton-endIcon {
                color: var(--color-bg-muted-alt);
              }
            }
          }


          &.Mui-children {
            flex-direction: column;

            .MuiBadge-root {
              position: absolute;
              right: ${theme.spacing(7)};
            }
          }

          .MuiCollapse-root {
            width: 100%;

            .MuiList-root {
              padding: 0px;
            }

            .MuiListItem-root {
              padding: 7px 0;

              .MuiButton-root {
                padding: ${theme.spacing(0.8, 3)};

                .MuiBadge-root {
                  right: ${theme.spacing(3.2)};
                }

                &:before {
                  content: ' ';
                  background: ${theme.colors.alpha.trueWhite[100]};
                  opacity: 0;
                  transition: ${theme.transitions.create([
                    'transform',
                    'opacity'
                  ])};
                  width: 6px;
                  height: 6px;
                  transform: scale(0);
                  transform-origin: center;
                  border-radius: 20px;
                  margin-right: ${theme.spacing(1.8)};
                }

                &.active,
                &:hover {

                  &:before {
                    transform: scale(1);
                    opacity: 1;
                  }
                }
              }
            }
          }
        }
      }
  `
);
export const siteAuditStyles = {
  selectDropdown: {
    backgroundColor: 'rgba(250, 250, 250, 1)',
    borderRadius: '6px',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'rgb(250,250,250) !important',
    height: '45px',
    width: '14.5rem',
    padding: '10px',
    display: 'flex',
    cursor: 'pointer',
    '& .MuiSelect-select': {
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      '&::-webkit-scrollbar': {
        width: '8px'
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(234, 236, 240, 1)',
        borderRadius: '10px'
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: 'rgba(220, 220, 220, 1)'
      }
    }
  },
  menuItem: {
    width: '100%',
    '&.Mui-selected': {
      backgroundColor: 'rgba(231, 223, 255, 1)',
      '&:hover': {
        backgroundColor: 'rgba(246, 243, 255, 1)'
      }
    },
    '&:hover': {
      backgroundColor: 'rgba(246, 243, 255, 1)'
    },
    marginRight: '5px'
  },
  stickyBox: {
    position: 'sticky',
    bottom: '-8px',
    background: 'white',
    marginBottom: '-11px'
  },
  button: {
    display: 'flex',
    left: '0px !important',
    marginLeft: '0px !important',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    color: 'grey !important'
  },
  buttonText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-14)',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  typographyCss: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: '500 !important',
    paddingLeft: '2px',
    color: 'var(--color-text-heading)',
    float: 'right',
    verticalAlign: 'middle',
    // display: 'contents',
    display: 'inline-block',
    width: '200px',
    whiteSpace: 'nowrap',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis'
  },
  chipCss: {
    fontSize: '10px',
    fontWeight: 'bolder',
    width: '40%',
    color: 'var(--color-primary)', // Text color
    backgroundColor: 'var(--color-secondary)',
    borderColor: 'var(--color-secondary)', // Border color
    marginLeft: 'auto',
    marginRight: '-12%',
    maxWidth: '71px'
  },
  listItemButtonCss: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: '500 !important',
    textAlign: 'left'
  },
  menuKeywordCss: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: '500 !important',
    paddingLeft: '23% !important'
  },
  auditNewSiteBtnBoxSx: {
    borderRadius: '6px',
    marginBottom: '10px'
  },
  auditNewSiteBtnText: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-14)',
    textAlign: 'left',
    color: 'var(--color-text-near-black)'
  },
  imgBoxSx: {
    fontSize: '10px',
    fontWeight: 'bolder',
    //width: '40%',
    color: 'var(--color-primary)', // Text color
    backgroundColor: '#362C58',
    //borderColor: 'var(--color-secondary)', // Border color
    marginLeft: 'auto',
    marginRight: '-4%',
    padding: '7px',
    borderRadius: '100%'
    //maxWidth: '71px'
  },
  sidebarMenuBox: {
    cursor: 'pointer !important'
  },
  auditNewSiteMenu: {
    height: '45px'
  },
  auditNewSiteBtnIcon: {
    color: 'var(--color-primary)'
  },
  premiumOrFreeUserMenuItem: {
    height: '45px'
  },
  premiumOrFreeUserMenuItemBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  premiumOrFreeUserMenuItemSubBox: (isFreePlan: boolean) => ({
    display: 'flex',
    gap: isFreePlan ? '6px' : '0px'
  }),
  addBtn: {
    color: 'rgba(48, 47, 50, 1)'
  },
  menuItemDivider: { mb: 1.2, mt: 1.2 },
  menuTitleBtn: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: '500 !important'
  },
  viewAllSiteBtnBox: {
    width: '100%',
    padding: '8px 9px 8px 9px'
  },
  auditNewSiteBtn: {
    maxHeight: '36px',
    gap: '6px',
    padding: '10px 16px 10px 16px',
    borderRadius: '6px',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)'
  },
  viewAllSitesBtn: {
    maxHeight: '36px',
    gap: '6px',
    padding: '10px 16px 10px 16px',
    borderRadius: '6px',
    border: '1px solid var(--color-text-muted-purple)',
    fontWeight: 600,
    marginTop: '8px',
    fontSize: 'var(--font-size-14)'
  },
  newChipSx: {
    marginLeft: '10px',
    backgroundColor: '#EEF4FF',
    borderRadius: '6px',
    padding: '2px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  newChipLabel: {
    color: '#3538CD',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1
  },
  newPdfChipSx: {
    marginLeft: '10px',
    backgroundColor: 'var(--color-success-bg)',
    borderRadius: '12px',
    padding: '4px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.08)'
  },
  newPdfChipLabel: {
    color: 'var(--color-primary)',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: 1
  }
};
